export default __webpack_public_path__ + "static/media/cycles1_eng.cb6ebc11.png";